export const AUTO_RELOAD_INTERVAL_MS = 60;
export const MS_PER_MIN = 1000;
